import React from 'react';
import { Typography, Box, Link } from '@mui/material';
import { LOGIN_LOGIN } from '../../constants';
import '../../style/Login.css';

interface CheckResetMailProps {
    setLoginPage: React.Dispatch<React.SetStateAction<string>>;
}

const CheckResetMail: React.FC<CheckResetMailProps> = ({setLoginPage}) => {
    const handleResendEmail = () => {
        // 在這裡添加重新發送郵件的邏輯
        console.log("Resend email clicked");
    };

    return (
        <>
            <Typography className='login_typography_title'>
                Check your mail box
            </Typography>
            <Typography className='login_typography_content'>
                Didn’t get the mail?{' '}
                <Link
                    href="#"
                    onClick={handleResendEmail}
                    className='login_link'
                >
                    Click here to resend it.
                </Link>
            </Typography>
            <Box display="flex" justifyContent="center" mt={2}>
                <Link
                    href="#"
                    color="primary"
                    underline="none"
                    onClick={() => setLoginPage(LOGIN_LOGIN)}
                >
                    Back to log in
                </Link>
            </Box>
        </>
    );
};

export default CheckResetMail;
